import template from 'text!./LocationTable.html';

export default [function () {
    return {
        restrict: 'E',
        scope: {
            schedule: '&'
        },
        template: template
    };
}];


//////////////////
// WEBPACK FOOTER
// ./app/customer/js/src/edge/policycommon/common/directives/schedules/scheduleTypes/readonly/LocationTable/LocationTable.js
// module id = 291
// module chunks = 0